import { useCallback } from 'react';
import { useNavigate } from 'js/hooks/navigate';
import { getCleanUrl } from 'js/utils/url.util';
import { languageService } from 'js/services/language.service';

export const useSetLanguagePathname = () => {
    const navigateWithReplace = useNavigate({ replace: true });

    return useCallback((langToSet: string, normalizeUrl?: boolean): void => {
        const pathLangAlias = languageService.getAliasForLanguage(langToSet);
        const pathLang = pathLangAlias === langToSet ? languageService.getShortLanguage(langToSet) : pathLangAlias;

        if (!pathLang) {
            return;
        }

        navigateWithReplace(`/${pathLang}${normalizeUrl ? getCleanUrl() : '/'}`);
    }, [navigateWithReplace]);
};
